import React, { memo } from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Star } from 'lucide-react';
export function ExtendedTestimonials() {
  const testimonials = [{
    name: 'Laura G.',
    role: 'Mamá de 3 años · Plan de Calma',
    content: 'Compré el MegaKit un domingo a la noche después de un día terrible. El lunes a la tarde ya estaba aplicando el Tomo 3. Fue la primera vez que logré calmar un berrinche sin gritar. Lloré de alivio.',
    rating: 5
  }, {
    name: 'Romina V.',
    role: 'Mamá de 2 y 5 años · Plan de Calma',
    content: 'Las tarjetas de rutinas son mágicas. Antes, irnos a dormir era una batalla campal de dos horas. Ahora mi hijo de 5 años busca su tarjeta y sabe exactamente qué toca. Nos cambió la dinámica familiar.',
    rating: 5
  }, {
    name: 'Florencia D.',
    role: 'Mamá de 4 años · Plan de Calma',
    content: 'Lo que más me sirvió fue entender que no me estaba manipulando. El Tomo 1 me voló la cabeza. Cuando cambiás la mirada, cambiás la respuesta. Ya no me enojo, ahora lo acompaño.',
    rating: 5
  }, {
    name: 'Julieta P.',
    role: 'Mamá de 2 años · Plan de Calma',
    content: 'Pensé que mi hija era muy chiquita para esto, pero los berrinches estaban siendo insoportables. Los guiones del Tomo 3 son tan simples que los memoricé enseguida. Funciona.',
    rating: 5
  }, {
    name: 'Micaela S.',
    role: 'Mamá de 3 años · Plan de Calma',
    content: 'El bono de las frases salvavidas lo tengo pegado en la heladera. Cuando siento que voy a explotar, lo leo y respiro. Es como tener a una psicóloga al lado diciéndote qué hacer.',
    rating: 5
  }];
  return <section className="py-20 md:py-28 bg-white border-t border-sage/10" data-id="element-78">
      <div className="container mx-auto px-4" data-id="element-79">
        <SectionWrapper data-id="element-80">
          <div className="text-center mb-16" data-id="element-81">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-playfair font-bold text-dark-green mb-4" data-id="element-82">
              Más familias que ya lo tienen
            </h2>
          </div>
        </SectionWrapper>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-83">
          {testimonials.map((t, i) => <SectionWrapper key={i} delay={0.1 * i} data-id="element-84">
              <div className="bg-offwhite border border-sage/10 rounded-2xl p-8 shadow-sm flex flex-col h-full hover:shadow-md transition-shadow" data-id="element-85">
                <div className="flex justify-between items-start mb-6" data-id="element-86">
                  <div className="flex items-center gap-4" data-id="element-87">
                    <div className="w-12 h-12 rounded-full bg-sage text-white flex items-center justify-center font-playfair font-bold text-xl shadow-sm" data-id="element-88">
                      {t.name.charAt(0)}
                    </div>
                    <div data-id="element-89">
                      <p className="font-poppins font-bold text-dark-green text-base" data-id="element-90">
                        {t.name}
                      </p>
                      <p className="font-poppins text-xs font-medium text-dark-green/60 mt-0.5" data-id="element-91">
                        {t.role}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="flex text-gold mb-4" data-id="element-92">
                  {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" stroke="none" data-id="element-93" />)}
                </div>

                <p className="font-poppins text-base text-dark-green/80 italic leading-relaxed flex-grow" data-id="element-94">
                  "{t.content}"
                </p>
              </div>
            </SectionWrapper>)}
        </div>
      </div>
    </section>;
}